import React from 'react';
import { SimulationScenario } from '@/components/Simulations';
import { useSimulationScenarioPrepFeature } from '@/features/simulations/simulation-scenario-prep/useSimulationScenarioPrepFeature';

/**
 * Composition component for preparing a simulation scenario.
 * Fetches necessary data from the global store and handles navigation.
 */
export const SimulationScenarioPrep: React.FC = ({ ...props }) => {
  const { activeCertification, activeSimulation, handleStartRolePlay, isLoading, personas } =
    useSimulationScenarioPrepFeature();

  return (
    <SimulationScenario
      category={activeSimulation?.category}
      certificationTitle={activeCertification?.title}
      instructions={activeSimulation?.instructions}
      isLoading={isLoading}
      onStartRolePlay={handleStartRolePlay}
      personas={personas}
      planningCards={activeSimulation?.planningCards}
      simulationId={activeSimulation?.id}
      title={activeSimulation?.title}
      type={activeSimulation?.type}
    />
  );
};

SimulationScenarioPrep.displayName = 'SimulationScenarioPrep';

export default SimulationScenarioPrep;
